import Cookies from 'js-cookie'

const TokenKey = 'token';

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  //天数
  // let in2Hours = 1 / 13
  let expireDays = 1;
  // 2018-12-30T11:01:12.000Z 东八区 为 19：01：12
  return Cookies.set(TokenKey, token, {expires: expireDays})
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js